import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {HallOpeningHour} from "types/entities/HallOpeningHour";
import Loader from "components/Loader";
import {useTypedSelector} from "helpers/reducers";

export interface GroupedData {
    [key: string]: HallOpeningHour[];
}

interface FooterSidebarCenterProps {}

const FooterSidebarCenter = (props: FooterSidebarCenterProps) => {
    const {t} = useTranslation();
    const hall = useTypedSelector(state => state.hallState.hall);
    const [openingHours, setOpeningHours] = useState<GroupedData>();

    const getDayName = (dayNumber: number): string => {
        const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        return daysOfWeek[dayNumber - 1];
    };

    const groupByOpeningHours = (data: HallOpeningHour[]): GroupedData => {
        return data.reduce((result: GroupedData, item) => {
            const key = `${item.opening_hours_from}-${item.opening_hours_to}`;
            if (!result[key]) {
                result[key] = [];
            }
            result[key].push(item);
            return result;
        }, {});
    };

    useEffect(() => {
        setOpeningHours(groupByOpeningHours(hall?.hallOpeningHours ? hall.hallOpeningHours : []));
    }, [hall]);

    if (!hall) {
        return <Loader />;
    }

    return (
        <div className={"FooterSidebarCenter w-auto flex flex-col gap-y-4 md:gap-y-6 text-left"}>
            <h2 className={"font-zuume font-bold text-[32px]"}>{t("Opening hours")}</h2>
            <div>
                <table className={"w-full lg:max-w-xs mx-auto sm:mx-0"}>
                    <tbody>
                    {openingHours &&
                        Object.entries(openingHours).map(([key, hours]) => {
                            const days = hours.map(hour => t(getDayName(hour.day))).join(", ");
                            const [openingHoursFrom, openingHoursTo] = key.split("-");
                            const hoursText =
                                openingHoursFrom === "0" && openingHoursTo === "0"
                                    ? t("Closed")
                                    : openingHoursFrom + ":00 " + t("h") + " - " + openingHoursTo + ":00 " + t("h");

                            return (
                                <tr key={key} className={"flex flex-col mb-1 last-of-type:mb-0"}>
                                    <td className="pr-1.5"><span className={"font-semibold"}>{days}</span></td>
                                    <td className="pr-1.5">{hoursText}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <a href="https://www.arbopark.ch/standort">
                <div
                    className="font-bold text-base md:text-[20px] inline-flex items-center text-center w-auto gap-2 transform-gpu duration-150 transition-all cursor-pointer no-underline text-black hover:text-black rounded-xl px-5 py-2.5 bg-gradient-arboYellowOrange hover:brightness-90"
                >
                    <span>{t("Public holidays / school holidays")}</span>
                </div>
            </a>
        </div>
    );
};

export default FooterSidebarCenter;